
import BaseIcon from '~/components/BaseIcon.vue';

export default {
  name: 'TetrisComponent',
  components: {
    BaseIcon,
  },
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    hideOnMobile: {
      type: Boolean,
      default: false,
    },
  },
};
